<template>
  <div class="bold">{{ formatTime(ts) }}</div>
</template>

<script>
export default {
  name: "item-ts-card",
  props: {
    ts: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  watch: {},
  computed: {},
};
</script>

<style lang="css">
.bold {
  font-weight: bold;
}
</style>
